"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpExcludeOptions = void 0;
class IpExcludeOptions {
}
exports.IpExcludeOptions = IpExcludeOptions;
